var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArabianboaticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flat"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m58.893 41h-3.893l-6 3h-44a2 2 0 0 0 -2 2 2 2 0 0 0 2 2h3l2.333 4h38.667l8-7h2a2 2 0 0 0 1.973-2.336 2.075 2.075 0 0 0 -2.08-1.664z",
    fill: "#dc6c54"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#8b3123"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17 48h2v4h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21 48h2v4h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 48h2v4h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 48h2v4h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 47h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35 47h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39 47h2v2h-2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m16 40h18v4h-18z",
    fill: "#f9bb4b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38 26a9.835 9.835 0 0 0 -7.692-10.635 24.5 24.5 0 0 1 -14.308 15.635s12 5 22 5z",
    fill: "#ad6327"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 12v4a10 10 0 0 1 10 10v18h4v-18a14 14 0 0 0 -14-14z",
    fill: "#7fcac9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.986 28.164-1.972-.328c.827-4.965-1.266-5.86-1.356-5.9l.658-1.887c.156.051 3.798 1.351 2.67 8.115z",
    fill: "#fff69a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33 30h2v2h-2z",
    fill: "#fff69a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 47h18v2h-18z",
    fill: "#f9bb4b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArabianboaticon);
export default __webpack_public_path__ + "static/media/arabianboaticon.832aad425ca7bf0e83263c6a20ba3565.svg";
export { ForwardRef as ReactComponent };